<template>
	<div>
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />

		<div class="page-error padding-top-20 padding-bottom-100">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 text-center margin-bottom-30">
						<h1>Ops</h1>
						<span>{{ $t('Misc.AnErrorOccurred') }}</span>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12 text-center">
						<h4 class="margin-bottom-70">
							<em>{{ message }}</em>
						</h4>
					</div>
				</div>

				<back-in-history></back-in-history>
			</div>
		</div>
	</div>
</template>

<script>
import BackInHistory from '@/components/atoms/BackInHistory'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'

export default {
	name: 'PageError',
	components: {
		BackInHistory,
		PageTitle,
	},
	mixins: [PageInfo],
	props: {
		code: {
			type: Number,
			default: 100,
		},
		info: {
			type: String,
			default: '',
		},
	},
	computed: {
		message() {
			const codeMessage = this.$t('Error.Code.' + this.code)
			const infoMessage = this.info ? this.$t('Error.Info.' + this.info) : ''

			return codeMessage.replace('${info}$', infoMessage)
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/views/PageError.vue